import certificate_bg_image from '../assets/image/CERTIFICATE.png'
import certificate_country_director from '../assets/image/certificate_country_director.png'
import certificate_head_of_edu from '../assets/image/certificate_head_of_edu.png'
import DefaultAvatar from '../assets/image/DefaultAvatar.svg'
import company_favicon from '../assets/image/favicon.svg'
import company_logo from '../assets/image/logo.svg'
import company_logo2 from '../assets/image/Logo2.svg'
import DefaultCourseThum from '../assets/image/thumbnail.png'

const siteConfig = {
    company_name: 'Al Imaan Institute',
    company_favicon: company_favicon,
    lazy_suspense_delay: 300,
    company_logo: company_logo,
    company_logo2: company_logo2,
    default_avatar: DefaultAvatar,
    default_course_thum: DefaultCourseThum,
    certificate_bg_image:certificate_bg_image,
    certificate_head_of_edu:certificate_head_of_edu,
    certificate_country_director:certificate_country_director,
    userRoles: ['Student', 'Instructor'],
    site_social_fb_link: 'https://www.facebook.com/myimaninstitute?ref=embed_page',
    site_social_instagram_link: 'https://www.instagram.com/alimaaninstitute/',
    site_social_twitter_link: 'https://x.com/AlIman627989688?t=22NC0NfQ8k78Kzo48U9xmg&s=09',
    site_social_youtube_link: 'https://www.youtube.com/@alimaaninstitute1853',
    product_currency:'৳',
    copyright_year:"2025",
    course_details_support_number:"+8801775-535751",
    contact_mail: "alimaaninstitute1@gmail.com",
    address: 'Shahjadpur Eidgah Mosque Road, Gulshan, Dhaka-1212',
    during_time: 'Saturday - Friday, 9 am to 8 pm',
    contact_number_one:"+8801775-535151",
    contact_number_two: "+8801733-979534",
    payment_number: '+8801711269477',
    rocket_number: '*322#',
    nagad_number: '*167#',
    bkash_number: '*247#',
    live_class_start_threshold_mins:10
}

export default siteConfig;